module.exports = __webpack_public_path__ + "static_portal/img/classic_style_concept2.f02d9d08.webp";